import { convertISODate } from "@entrilia/shared/utilities/dateUtils";
import { reportingPeriodCaptionsMap } from "@entrilia/shared/utilities/enumCaptions";
import type { DataCollectionRequestDetails } from "../../../../../api/types/dataCollectionTypes";
import { dataCollectionRequestAuditoryCaptionsMap } from "../../../../../utilities/enumCaptions";
import HorizonatalTilesInfoBar from "../../../../common/HorizontalTilesInfoBar";
import StepsProgress from "../../../../common/StepsProgress";

interface Props {
  dataRequest: DataCollectionRequestDetails;
}

const DataRequestInfoSection = ({ dataRequest }: Props) => {
  return (
    <HorizonatalTilesInfoBar
      items={[
        { title: "Scenario", content: dataRequest.scenarioName },
        { title: "Period", content: reportingPeriodCaptionsMap[dataRequest.templateReportingPeriod] },
        { title: "Template", content: dataRequest.templateName },
        { title: "Reporting Date", content: convertISODate(dataRequest.reportingDate) },
        {
          title: "Recipient Type",
          content: dataCollectionRequestAuditoryCaptionsMap[dataRequest.auditory] ?? dataRequest.auditory,
        },
        {
          title: "Progress",
          content: (
            <StepsProgress completed={dataRequest.submittedSubmissions} total={dataRequest.submissions.length} />
          ),
          gridProps: { size: 4, sx: { pr: 2.5 } },
        },
      ]}
    />
  );
};

export default DataRequestInfoSection;
